import { Component, Input, OnInit, Output, EventEmitter, ViewEncapsulation, OnChanges } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'sortable-dropdown-editor',
  templateUrl: './sortable-dropdown-editor.component.html',
  styleUrls: ['./sortable-dropdown-editor.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SortableDropdownEditorComponent implements OnInit, OnChanges {
  @Input() options: any[];
  @Input() title: string;
  @Input() showColor: boolean = false;
  @Output() onUpdate: EventEmitter<any> = new EventEmitter();
  @Output() onAdd: EventEmitter<any> = new EventEmitter();
  @Output() onDelete: EventEmitter<any> = new EventEmitter();

  numOptions: number[] = [];

  dropdownForm: UntypedFormGroup;

  constructor(private _formBuilder: UntypedFormBuilder) {}

  ngOnInit() {
    this.renderOptions();
  }

  renderOptions() {
    this.dropdownForm = this._formBuilder.group({
      options: this._formBuilder.array([]),
      newOption: this._formBuilder.group({
        name: ['', Validators.required],
      }),
    });
    this.options.forEach((option) => {
      const formGroup = this._formBuilder.group({
        name: [option, Validators.required],
      });

      // Add the label form group to the labels form array
      (this.dropdownForm.get('options') as UntypedFormArray).push(formGroup);
    });

    this.numOptions = [];
    for (let i = 0; i < this.options.length; i++) {
      this.numOptions.push(i);
    }

    this.dropdownForm
      .get('options')
      .valueChanges.pipe(debounceTime(500))
      .subscribe(() => {
        this.updateOptions();
      });
  }

  ngOnChanges() {
    this.renderOptions();
  }

  updateOptions(): void {
    (this.dropdownForm.get('options') as UntypedFormArray).controls.forEach((formGroup) => {
      if (formGroup.dirty) {
        let option = { name: formGroup.value.name };
        this.onUpdate.emit(option);
      }
    });

    this.dropdownForm.get('options').markAsPristine();
    this.dropdownForm.get('options').markAsUntouched();

    this.renderOptions();
  }

  addOption(): void {
    const val = this.dropdownForm.get('newOption').value;
    this.onAdd.emit(val);

    this.dropdownForm.get('newOption').markAsPristine();
    this.dropdownForm.get('newOption').markAsUntouched();
    this.dropdownForm.get('newOption.name').reset();
    this.dropdownForm.get('newOption.name').clearValidators();
    this.dropdownForm.get('newOption.name').updateValueAndValidity();

    this.renderOptions();
  }

  delete(option) {
    this.onDelete.emit(option.value.name);
    this.dropdownForm.get('options').markAsPristine();
    this.dropdownForm.get('options').markAsUntouched();

    this.renderOptions();
  }
}
